import React from "react";
import AdPanelList from "../components/AdPanelList";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader from "../components/PanelAdsHeader";
import AdListSkeleton from "../components/AdListSkeleton";
import { connect } from "react-redux";
import * as actions from "../redux/actions/adDonationActions";
import "./styles/PanelAds.css";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

class AdDonations extends React.Component {
  componentDidMount() {
    this.fetchAdDonationList();
  }

  fetchAdDonationList = async () => {
    try {
      await this.props
        .LoadPublish(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadPublishMore(
          this.props.pageCount,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const count = this.props.adlist?.length || 0;

    return (
      <PanelLayout>
        <div className="panel-ads-page">
          <PanelAdsHeader
            title={<Translate value="ad_donation" />}
            newTo="/goder/new/donation"
            subtitle={
              !this.props.loading && count > 0
                ? `${count} ${I18n.t("ads")}`
                : null
            }
          />

          {this.props.loading ? (
            <AdListSkeleton count={6} />
          ) : (
            <AdPanelList
              adPanelList={this.props.adlist}
              loadingMore={this.props.loadingMore}
              pageCount={this.props.pageCount}
              pageSize={this.props.pageSize}
              onClickLoadMore={this.onClickLoadMore}
            />
          )}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    adlist: reducer.adDonation.list,
    error: reducer.adDonation.error,
    loading: reducer.adDonation.loading,
    loadingMore: reducer.adDonation.loadingMore,
    pageCount: reducer.adDonation.page_count,
    pageSize: reducer.adDonation.page_size,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadPublish: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
  LoadPublishMore: (page_count, user_id, token) =>
    dispatch(actions.loadListScroll({ page_count, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdDonations);
